import React from "react";
import { useTranslation } from "react-i18next";

import { STATUS_META } from "../../utils/orderStatus";

const TONE_CLASSES = {
  neutral:
    "bg-offwhite text-text-secondary border border-border-subtle",
  info:
    "bg-status-progress/10 text-status-progress border border-status-progress/20",
  "info-alt":
    "bg-taupe/10 text-taupe border border-taupe/25",
  success:
    "bg-status-available/10 text-status-available border border-status-available/20",
  warning:
    "bg-status-limited/10 text-status-limited border border-status-limited/25",
  danger:
    "bg-status-unavailable/10 text-status-unavailable border border-status-unavailable/25",
};

const SIZE_CLASSES = {
  sm: "text-[10px] px-1.5 py-0.5",
  md: "text-xs px-2 py-0.5",
  lg: "text-sm px-3 py-1",
};

/** Renders a translated, colour-coded status pill for any OrderStatus. */
export function StatusBadge({ status, size = "md", className = "" }) {
  const { t } = useTranslation();
  const meta = STATUS_META[status] || STATUS_META.draft;
  const tone = TONE_CLASSES[meta.tone] || TONE_CLASSES.neutral;
  const sz = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center whitespace-nowrap rounded-full font-medium uppercase tracking-wide ${tone} ${sz} ${className}`}
    >
      {t(meta.i18n)}
    </span>
  );
}
